import axios from "axios";
import { ApiMessage } from "../shared/interfaces";
import { comparatorMessageNewToOld } from "../util/objectUtil";

export const AdminApi = {
    getOverview: async (): Promise<ApiMessage[]> => {
        const resp = await axios.get("/api/admin/overview");
        return resp.data.sort(comparatorMessageNewToOld);
    },

    getKgFiles: async (): Promise<{ file_id: string; document_type: string }[]> => {
        const resp = await axios.get("/api/admin/kgFileInfo");
        return resp.data;
    },
};
